export default "__VITE_ASSET__4vMgVM$J__"